import { defaultMessageBackend, noValidation } from '@post-office/placement-common-v2';
import {
	PlacementBackend,
	PlacementFrontend,
} from '@post-office/placements--growth-starburst/jira-project-space-connected';

import { ProjectPagesSpotlight } from './components/ProjectPagesSpotlight';

export type PlacementContext = {
	title: string;
	description: string;
	onView: () => void;
};

export const MessageBackend = PlacementBackend.createMessageBackend(defaultMessageBackend);

export const MessageFrontend = PlacementFrontend.createMessageFrontend({
	render: {
		validate: noValidation<PlacementContext>(),
		Component: ({ title, description, onView }: React.PropsWithChildren<PlacementContext>) => (
			<ProjectPagesSpotlight title={title} description={description} onView={onView} />
		),
	},
});
